export var SETTER_ACTIONS = /*#__PURE__*/ function(SETTER_ACTIONS) {
    SETTER_ACTIONS[SETTER_ACTIONS["insert"] = 0] = "insert";
    SETTER_ACTIONS[SETTER_ACTIONS["remove"] = 1] = "remove";
    SETTER_ACTIONS[SETTER_ACTIONS["set"] = 2] = "set";
    return SETTER_ACTIONS;
}({});
export var CONTROL_ACTIONS = /*#__PURE__*/ function(CONTROL_ACTIONS) {
    CONTROL_ACTIONS["command"] = "COMMAND";
    CONTROL_ACTIONS["reset"] = "RESET";
    return CONTROL_ACTIONS;
}({});

//# sourceMappingURL=types.js.map